import { fetchBaseQuery, retry } from '@reduxjs/toolkit/query';

const baseQuery = retry(
  async (args, api, extraOptions) => {
    const result = await fetchBaseQuery({
      baseUrl: '',
      prepareHeaders: async (headers) => {
        headers.set('Accept-Language', L10n.selectedLang || 'en');
        if (!headers.get('Accept')) {
          headers.set('Accept', 'application/json');
        }
        if (!headers.get('Content-Type')) {
          headers.set('Content-Type', 'application/json');
        }
        if (localStorage.getItem('adminx__token') && !headers.get('Authorization')) {
          headers.set('Authorization', `Bearer ${localStorage.getItem('adminx__token')}`);
        }
        return headers;
      },
    })(args, api, extraOptions);
    if (
      result.error &&
      (result.error.status === 401 ||
        result.error.status === 404 ||
        result.error.status === 403 ||
        result.error.status === 420 ||
        result.error.status === 304)
    ) {
      retry.fail(result.error);
    }
    return result;
  },
  {
    maxRetries: 0,
  },
);
export { baseQuery };
